import { OURVEHICLE_GET_LIST,OURVEHICLE_GET_LIST_SUCCESS,OURVEHICLE_GET_LIST_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getOurVehicleList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case OURVEHICLE_GET_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case OURVEHICLE_GET_LIST_SUCCESS:
            console.log('OURVEHICLE_GET_LIST_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getOurVehicleList: action.data,
                error: '',
                messages: ''
            };
        case OURVEHICLE_GET_LIST_ERROR:
            return {
                ...state,
                loading: false,
                getOurVehicleList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};
